/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch } from 'dva';
import SvgIcon from '@/components/SvgIconML/SvgIconML';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import {
  Box,
  TextField,
  // FormControlLabel,
  // Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  // InputLabel,
  FormHelperText,
  Button,
} from '@material-ui/core';
import { useIntl } from 'umi';
import { Controller, useForm } from 'react-hook-form';
import { Form, message } from 'antd';
import ButtonML from '@/components/button_ml/ButtonML';
import InputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import { cryptoEncrypt } from '@/utils/aes';
import webStorage from '@/utils/storageManager';
import { history } from 'umi';
import ChangePasswordStyled from './ChangePasswordStyled';

const HeaderComm = ({ handleCancel }) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { handleSubmit, control, errors, getValues } = useForm({});
  const dispatch = useDispatch();
  const user = webStorage.get('USER');
  const [values, setValues] = React.useState({
    password: '',
    ensurePassword: '',
    weight: '',
    weightRange: '',
    showPassword: false,
    showEnsurePassword: false,
  });

  // 发起请求
  const onFinish = (value) => {
    console.log('value', value);
    const crypedOriginalPassword = cryptoEncrypt(value.originalPassword);
    const crypedNewPassword = cryptoEncrypt(value.newPassword);
    dispatch({
      type: 'common/changePassword',
      payload: {
        values: {
          originalPassword: crypedOriginalPassword,
          newPassword: crypedNewPassword,
        },
        userId: user.id,
      },
      callback: (data) => {
        if (data.code === 0) {
          message.success('密码修改成功');
          handleCancel();
          history.push('/login');
        } else {
          window.message.toast({
            type: 'error',
            message: data.message,
            title: '失败',
          });
          // message.error(data.message);
        }
      },
    });
  };
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowEnsurePassword = () => {
    setValues({ ...values, showEnsurePassword: !values.showEnsurePassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const validator = {
    password: (e) => {
      if (e !== getValues().originalPassword) {
        return true;
      }
      return false;
    },
    ensurePassword: (e) => {
      if (e === getValues().newPassword) {
        return true;
      }
      return false;
    },
  };
  const onFailed = (error) => {
    console.log('error', error);
  };

  return (
    <ChangePasswordStyled>
      <form onSubmit={handleSubmit(onFinish, onFailed)}>
        <Box className="line">
          <Controller
            as={
              <TextField
                id="input-with-icon-textfield"
                className="username"
                autoComplete="off"
                placeholder={formatMessage({
                  id: 'login.n01.placeholder03',
                })}
                variant="standard"
                error={Boolean(errors.originalPassword)}
                // helperText={
                //   Boolean(errors.originalPassword) &&
                //   formatMessage({ id: 'login.d01.lbl01' })
                // }
              />
            }
            name="originalPassword"
            label={
              <>
                <span className="red">*</span>
                {formatMessage({ id: 'login.d01.lbl01' })}
              </>
            }
            control={control}
            rules={{ required: true }}
            defaultValue={''}
          />
        </Box>
        <Box className="line" mt={4}>
          <FormControl
            variant="standard"
            className="pwd"
            error={Boolean(errors.password)}
          >
            <Controller
              as={
                <TextField
                  name="newPassword"
                  placeholder={formatMessage({
                    id: 'login.n01.placeholder03',
                  })}
                  label={
                    <>
                      <span className="red">*</span>
                      {formatMessage({
                        id: 'login.d01.lbl02',
                      })}
                    </>
                  }
                  variant="standard"
                  type={values.showPassword ? 'text' : 'password'}
                  value={values.password || ''}
                  autoComplete="off"
                  onChange={handleChange('password')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {values.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors.newPassword)}
                  // helperText={
                  //   Boolean(errors.newPassword?.type === 'required') ??
                  //   formatMessage({ id: 'login.n01.msg08' })
                  // }
                />
              }
              name="newPassword"
              control={control}
              rules={{
                required: true,
                validate: (value) => {
                  return validator.password(value);
                },
              }}
              defaultValue={''}
            />
          </FormControl>
        </Box>
        <FormHelperText error={Boolean(errors.newPassword)}>
          {Boolean(errors?.newPassword?.type === 'validate') &&
            '新密码不能与旧密码重复'}
        </FormHelperText>
        <Box className="line" mt={3}>
          <FormControl
            variant="standard"
            className="pwd"
            error={Boolean(errors.ensurePassword)}
          >
            <Controller
              as={
                <TextField
                  className="password"
                  name="ensurePassword"
                  placeholder={formatMessage({
                    id: 'login.n01.placeholder03',
                  })}
                  label={
                    <>
                      <span className="red">*</span>
                      {formatMessage({
                        id: 'login.d01.lbl03',
                      })}
                    </>
                  }
                  variant="standard"
                  type={values.showEnsurePassword ? 'text' : 'password'}
                  value={values.ensurePassword || ''}
                  autoComplete="off"
                  onChange={handleChange('ensurePassword')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowEnsurePassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {values.showEnsurePassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors.ensurePassword)}
                  // helperText={
                  //   Boolean(errors.ensurePassword?.type === 'required') ??
                  //   formatMessage({ id: 'login.n01.msg08' })
                  // }
                />
              }
              name="ensurePassword"
              control={control}
              rules={{
                required: true,
                validate: (newValue) => {
                  return validator.ensurePassword(newValue);
                },
              }}
              defaultValue={''}
            />
          </FormControl>
        </Box>
        <FormHelperText error={Boolean(errors.ensurePassword)}>
          {Boolean(errors.ensurePassword?.type === 'validate') &&
            '两次输入密码不一致'}
        </FormHelperText>
        <Box mt={7} className="button-group">
          <Button
            className="cancel-button"
            onClick={() => handleCancel()}
            startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
            variant="contained"
            color="secondary"
          >
            取 消
          </Button>
          <Button
            variant="contained"
            type="submit"
            className="btnSubmit button"
            startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
            // onClick={onSubmitUserGroupData}
          >
            确 定
          </Button>
        </Box>
        {/* <Form form={form} name="control-hooks" onFinish={onFinish}>
        <div className={styles.input_contain}>
          <InputML
            labelVal="原密码"
            placeVal="请输入原密码"
            name="originalPassword"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入原密码',
              },
            ]}
          />

          <InputML
            labelVal="新密码"
            placeVal="请输入新密码"
            name="newPassword"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请输入新密码',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || validator.password(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject('新密码不能与旧密码重复');
                },
              }),
            ]}
          />

          <InputML
            labelVal="确认密码"
            placeVal="请再次输入新密码"
            name="ensurePassword"
            required={[
              {
                required: true,
                whitespace: true,
                message: '请再次输入新密码',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || validator.ensurePassword(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject('两次新密码不同');
                },
              }),
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form> */}
      </form>
    </ChangePasswordStyled>
  );
};

export default HeaderComm;
